<div class="folder-item" [class.folder-done]="isDone()" (click)="open.emit(field())">
    <div class="folder-left">
        <!-- Checkbox de conclusão da pasta -->
        <span
            class="folder-check"
            (click)="$event.stopPropagation()"
            [raTooltip]="{ text: canComplete() ? '' : ('document.edit.checklist.onlyResponsibles' | translate), position: 'right' }">
            <ra-checkbox
                [disabled]="!canComplete()"
                [ngModel]="isDone()"
                (ngModelChange)="onToggleDone($event)" />
        </span>

        <ra-icon icon="folder" [varColor]="isDone() ? 'accentGreen' : 'primary'" [size]="20" />

        <div class="folder-infos">
            <p class="ra-label-s ra-overflow-ellipsis folder-name" [class.folder-name-done]="isDone()">
                {{ field().name }}
            </p>
            <p class="ra-label-xs content-tertiary">
                {{ 'document.edit.checklist.folder.fieldsCount' | translate:{ count: childCount() } }}
            </p>
        </div>
    </div>

    <ra-icon icon="arrow-right" varColor="currentColor" [size]="18" />
</div>
